import { Provider } from './Provider';
import { initRecaptcha } from '../../helpers/captchas';
export class LocalStorageProvider extends Provider {
    data = {};
    constructor() {
        super();
        this.initTrackingData();
        this.initConsent();
    }
    initTrackingData() {
        const trackingDataString = window.localStorage.getItem('trackingData');
        if (!trackingDataString) {
            return;
        }
        try {
            const trackingData = JSON.parse(trackingDataString);
            if (trackingData) {
                this.data = trackingData;
            }
        }
        catch (e) {
            console.error('Could not parse tracking data in local storage: ' + e);
        }
    }
    initConsent() {
        const localStorageConsent = localStorage.getItem('uc_gcm');
        if (!localStorageConsent) {
            return;
        }
        try {
            initRecaptcha();
            const localStorageConsentJSON = JSON.parse(localStorageConsent);
            const trackingHandler = window.trackingHandler;
            trackingHandler.consent.essential = true;
            trackingHandler.consent.marketing = localStorageConsentJSON['adStorage'] === 'granted';
            trackingHandler.consent.functional = localStorageConsentJSON['analyticsStorage'] === 'granted';
        }
        catch (e) {
            console.error('Could not parse consent data in local storage: ' + e);
        }
    }
    get visitorId() {
        return this.data.visitorId || null;
    }
    get visitorTimestamp() {
        const visitorTimestampString = window.sessionStorage.getItem('visitorTimestamp');
        if (!visitorTimestampString) {
            return window.trackingHandler.viewTimestamp;
        }
        return parseInt(visitorTimestampString);
    }
    get isCustomer() {
        return this.data.isCustomer || null;
    }
}
